import { VALIDATION_KEYS } from '@fysaro/shared';
import { z } from 'zod';

export const createInvoiceSchema = z.object({
  patientId: z.string().uuid(VALIDATION_KEYS.INVOICE.INVALID_UUID),
  professionalId: z.string().uuid(VALIDATION_KEYS.INVOICE.INVALID_UUID),
  items: z.array(z.object({
    description: z.string().min(1),
    quantity: z.number().min(1),
    unitPrice: z.number().min(0), // Siempre en céntimos
    taxRate: z.number().default(21),
  })).min(1),
  notes: z.string().optional(),
});

export const updateInvoiceSchema = z.object({
  status: z.enum(["DRAFT", "EMITTED", "PAID", "CANCELLED"]).optional(),
  notes: z.string().max(500).optional().nullable(),
})

export const sendInvoiceSchema = z.object({
  id: z.string().uuid(),
})